import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Updating local and global packages you downloaded from the registry helps keep your code and tools stable, usable, and secure.`}</p>
    <h2>{`Updating local packages`}</h2>
    <p>{`We recommend regularly updating the local packages your project depends on to improve your code as improvements to its dependencies are made.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Navigate to the root directory of your project and ensure it contains a `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`cd /path/to/project
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In your project root directory, run the `}<a parentName="p" {...{
            "href": "/cli/update"
          }}><inlineCode parentName="a">{`update`}</inlineCode>{` command`}</a>{`:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`npm update
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`To test the update, run the `}<a parentName="p" {...{
            "href": "/cli/outdated"
          }}><inlineCode parentName="a">{`outdated`}</inlineCode>{` command`}</a>{`. There should not be any output.`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`npm outdated
`}</code></pre>
      </li>
    </ol>
    <h2>{`Updating globally-installed packages`}</h2>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` If you are using npm version 2.6.0 or less, run `}<a parentName="p" {...{
          "href": "https://gist.github.com/othiym23/4ac31155da23962afd0e"
        }}>{`this script`}</a>{` to update all outdated global packages.`}</p>
      <p>{`However, please consider upgrading to the latest version of npm:`}</p>
      <pre><code parentName="pre" {...{}}>{`npm install npm@latest -g
`}</code></pre>
    </Note>
    <h3>{`Determining which global packages need updating`}</h3>
    <p>{`To see which global packages need to be updated, on the command line, run:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm outdated -g --depth=0
`}</code></pre>
    <h3>{`Updating a single global package`}</h3>
    <p>{`To update a single global package, on the command line, run:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm update -g <package_name>
`}</code></pre>
    <h3>{`Updating all globally-installed packages`}</h3>
    <p>{`To update all global packages, on the command line, run:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm update -g
`}</code></pre>
    <h2>{`Resources`}</h2>
    <iframe src="https://www.youtube.com/embed/HRudtPGcOt4" frameBorder="0" allowFullScreen></iframe>
    <h3>{`CLI commands`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/update"
        }}>{`npm-update`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/outdated"
        }}>{`npm-outdated`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      